import OperationBlock_vue_vue_type_script_setup_true_lang_default from "./OperationBlock.vue.script.js";
//#region src/v2/blocks/operation-block/OperationBlock.vue
var OperationBlock_default = OperationBlock_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { OperationBlock_default as default };

//# sourceMappingURL=OperationBlock.vue.js.map